import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { checkReportStatus } from 'partner360/services/report/checkReportStatus'
import { IGenerateReportArgs } from 'partner360/services/report/generateReport'

import { generateReports } from '../../api'
import { downloadReports } from '../../api/downloadReports'
import { MULTI_EXPORT_POLL_INTERVAL_MS } from '../../configs'
import { multiExportGeneratingFinished, multiExportStatusUpdated } from '../slice'
import { IMultiExportReportEntry } from '../types'

interface IGenerateAndPollReportsArgs {
  reportsPayload: IGenerateReportArgs[]
  archiveName: string
}

const pollUntilComplete = (
  reports: IMultiExportReportEntry[],
  dispatch: (action: unknown) => void
): Promise<number[]> =>
  new Promise((resolve) => {
    const poll = (current: IMultiExportReportEntry[]) => {
      setTimeout(async () => {
        const statusList = await checkReportStatus()

        const updated: IMultiExportReportEntry[] = statusList
          .filter((it) => current.some((el) => el.entryId === it.EntryId))
          .map((it) => ({
            entryId: it.EntryId,
            inProgress: ['Starting', 'In Progress'].includes(it.Status),
          }))

        dispatch(multiExportStatusUpdated(updated))

        const allDone = updated.every((it) => !it.inProgress)
        if (allDone) {
          resolve(updated.map((it) => it.entryId))
        } else {
          poll(updated)
        }
      }, MULTI_EXPORT_POLL_INTERVAL_MS)
    }

    poll(reports)
  })

export const generateAndPollReports = createAsyncThunk(
  'reports/generateAndPollReports',
  async ({ reportsPayload, archiveName }: IGenerateAndPollReportsArgs, { dispatch }) => {
    const response = await generateReports(reportsPayload)

    const initialEntries: IMultiExportReportEntry[] = response.data.map((it) => ({
      entryId: it.EntryId,
      inProgress: true,
    }))

    dispatch(multiExportGeneratingFinished(initialEntries))

    const completedEntryIds = await pollUntilComplete(initialEntries, dispatch)

    await downloadReports(completedEntryIds, archiveName)
  }
)
